import { SET_PRESENTATION_LIST, SET_PRESENTATION_USER_NAME, USER_NAME_STORAGE_KEY } from './constants';
export default {
  async setList({ commit, state }, value) {
    commit(SET_PRESENTATION_LIST, value);
  },
  async updateUserName({ commit }, userName) {
    localStorage.setItem(USER_NAME_STORAGE_KEY, userName);
    commit(SET_PRESENTATION_USER_NAME, userName);
  }
};
